module.exports = __webpack_public_path__ + "img/ic_add_14_white.9aa6ca4e.svg";